import { render } from "./ChartsDemo.vue?vue&type=template&id=fe890d32"
import script from "./ChartsDemo.vue?vue&type=script&lang=js"
export * from "./ChartsDemo.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__